/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_BodyInputs */



/**
* | output |
* | --- |
* | "Sitting in the same room? Record the conversation with this device's microphone and Wundo writes the report." |
*
* @param {Meeting_Offline_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_body = /** @type {((inputs?: Meeting_Offline_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zit je samen in één ruimte? Neem het gesprek op met de micro van dit toestel, dan schrijft Wundo het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes dans la même pièce ? Enregistrez la conversation avec le micro de cet appareil, et Wundo rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("Sitting in the same room? Record the conversation with this device's microphone and Wundo writes the report.")
});